export default "__VITE_ASSET__Cb92_bHD__"